// src/lib/airtable.js

// In Create React App, environment variables from .env are accessible via process.env
// They MUST start with REACT_APP_ to be exposed to the browser
const BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID || 'appwaJ9r0c6xZhEPh';
const PAT = process.env.REACT_APP_AIRTABLE_PAT;
const BASE_URL = `https://api.airtable.com/v0/${BASE_ID}`;

const headers = {
  Authorization: `Bearer ${PAT}`,
  'Content-Type': 'application/json',
};

// Debug: log the config on load
console.log('🔧 Airtable initialized. Base ID:', BASE_ID);
if (!PAT) {
  console.error('❌ ERROR: REACT_APP_AIRTABLE_PAT is missing from .env file');
}

// ─── Business Settings ───────────────────────────────────────────────────────

export async function getBusinessByEmail(email) {
  const url = `${BASE_URL}/Business%20Settings?filterByFormula=${encodeURIComponent(`{Owner Email}="${email}"`)}`;
  const res = await fetch(url, { headers });
  const data = await res.json();
  if (!data.records || data.records.length === 0) return null;
  return { id: data.records[0].id, ...data.records[0].fields };
}

export async function createBusiness(fields) {
  const res = await fetch(`${BASE_URL}/Business%20Settings`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ fields, typecast: true }),
  });
  const data = await res.json();
  
  if (!res.ok) {
    console.error('❌ Airtable API error:', data);
    throw new Error(data.error?.message || 'Failed to create business record');
  }
  
  console.log('✅ Airtable response:', data);
  return { id: data.id, ...data.fields };
}

export async function updateBusiness(recordId, fields) {
  const res = await fetch(`${BASE_URL}/Business%20Settings/${recordId}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify({ fields, typecast: true }),
  });
  const data = await res.json();
  if (!res.ok) {
    console.error('❌ Airtable updateBusiness error:', data);
    throw new Error(data.error?.message || 'Failed to update business record');
  }
  return { id: data.id, ...data.fields };
}

// ─── Bookings ────────────────────────────────────────────────────────────────

export async function getBookingsByBusiness(businessName) {
  const url = `${BASE_URL}/Bookings?sortField=Date%20Booked&sortDirection=desc&maxRecords=50`;
  const res = await fetch(url, { headers });
  const data = await res.json();
  if (!data.records) return [];
  return data.records.map(r => ({ id: r.id, ...r.fields }));
}

export async function getBookingStats(businessName) {
  const bookings = await getBookingsByBusiness(businessName);
  const now = new Date();
  const thisMonth = bookings.filter(b => {
    if (!b['Date Booked']) return false;
    const d = new Date(b['Date Booked']);
    return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
  });
  return {
    totalBookings: bookings.length,
    monthBookings: thisMonth.length,
    allBookings: bookings,
  };
}

export async function updateBooking(recordId, fields) {
  const res = await fetch(`${BASE_URL}/Bookings/${recordId}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify({ fields }),
  });
  const data = await res.json();
  return { id: data.id, ...data.fields };
}
